module.exports = __webpack_public_path__ + "img/hero-2.32b52875.jpeg";